import LottieView from 'lottie-react-native'
import type { ReactElement } from 'react'
import React from 'react'
import { View } from 'react-native'

import type { Animation as AnimationProps } from '@flows/core/types/stepContentTypes'
import type { FlowValues } from '@flows/core/types/stepTypes'

export const Animation = <TProps extends AnimationProps>(
  props: TProps & { flowValues: FlowValues; children?: ReactElement }
) => {
  return (
    <View className="flex w-full flex-row justify-center">
      <View
        style={{
          width: props.width,
          height: props.height,
        }}
      >
        <LottieView source={props.source} loop={false} autoPlay />
      </View>
    </View>
  )
}
